/* ==========================================================================
   NUKKA — predictive-search.js
   Debounced suggestions via /search/suggest.json. Results built in JS.
   ========================================================================== */
(function () {
  'use strict';
  var N = window.NUKKA || (window.NUKKA = {});

  N.register(function (scope) {
    var el = scope.querySelector('#SearchDrawer') || (scope.id === 'SearchDrawer' ? scope : null);
    if (!el || el._init) return; el._init = true;
    var input = el.querySelector('[data-predictive-input]');
    var results = el.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer, controller;

    function escapeHtml(s) { return (s || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

    function render(data, term) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
      if (!products.length && !articles.length) {
        results.innerHTML = '<p class="hand" style="font-size:1.3rem">No results for "' + escapeHtml(term) + '". Try another detour.</p>';
        return;
      }
      var html = '';
      if (products.length) {
        html += '<ul class="predictive__list">';
        products.forEach(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="56" height="56" loading="lazy">' : '';
          html += '<li><a class="predictive__item" href="' + p.url + '">' +
                  '<span class="predictive__thumb">' + img + '</span>' +
                  '<span><span class="predictive__title">' + escapeHtml(p.title) + '</span>' +
                  '<span class="predictive__price">' + (N.showPrices && p.price ? N.formatMoney(Math.round(parseFloat(p.price) * 100)) : '') + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      if (articles.length) {
        html += '<p class="footer__col-title" style="margin-top:1rem">Journal</p><ul class="predictive__list">';
        articles.forEach(function (a) {
          html += '<li><a class="predictive__item" href="' + a.url + '"><span class="predictive__title">' + escapeHtml(a.title) + '</span></a></li>';
        });
        html += '</ul>';
      }
      html += '<a class="link-arrow mt-1" href="' + N.routes.search_url + '?q=' + encodeURIComponent(term) + '">View all results →</a>';
      results.innerHTML = html;
    }

    function search() {
      var term = input.value.trim();
      if (term.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      var url = N.routes.predictive_search_url + '?q=' + encodeURIComponent(term) +
                '&resources[type]=product,article&resources[limit]=6&section_id=';
      // suggest.json fallback when predictive endpoint missing
      var suggestUrl = '/search/suggest.json?q=' + encodeURIComponent(term) +
                       '&resources[type]=product,article&resources[limit]=6';
      fetch(suggestUrl, { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(d, term); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(search, 220);
    });
  });
})();
